import React from "react";
import DataStreamComp from "./datastreams.component";
import AsanaLogin from "./asaLogin.component";
import AsanaPostLogin from "./asanaPostLogin";
import MsPlanner from "./msPlanner.component";
import JiraIntegrationPopup from "../jiraIntegrationPopup";
import JiraPostLogin from "./jiraPostLogin";
import { ErrorTextComp } from "../../../inputs/fields.component";
import DeleteCommonModal from "../../../../components/deleteCommonModal.component";
import RetainUpdateModal from '../../../../components/retainUpdateModal.component';
import AdoPostLogin from "./AdoPostLogin";
import ADOPopup from "../ADOPopup";
import { withTranslation } from "react-i18next";
import KpiMarketPlaceDataSourceEdit from "../kpiMarketPlaceDataSourceEdit";
import { isKpiMarketPlaceExternalApp, getKpiExternalAppKpiTypeById} from "../../../../utils/kpi-market-place-util";

class KpiTypeComp extends React.Component {
  constructor(props) {
    super(props);
    let kpiType = this.getKpiTypeFromItem();
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    this.state = {
      kpiType: this.props.kpiType || kpiType,
      errors: {},
      jira: {
        metricObj: this.props.item,
        shouldShowJiraLogin: !this.props.addOkrData.goalDetails.externalApps
          .jira,
        jiraLoggedIn: !!this.props.addOkrData.goalDetails.externalApps.jira,
        jiraRepoData: [],
        checkRepos: []
      },
      msp: {
        metricObj: this.props.item
      },
      showAsanaLogin: !this.props.addOkrData.goalDetails.externalApps.asana,
      showMspLogin: !this.props.addOkrData.goalDetails.externalApps.ms_planner,
      isAdoConnected: this.props.addOkrData.goalDetails.externalApps.ado,
      salesforce: {
        isSelected: kpiType === 'salesforce',
        editMode: (
          this.props.item &&
          this.props.item.id &&
          this.props.item.source == 8 &&
          this.props.item.ext_app_id == 17 &&
          kpiType === 'salesforce'
        ) ? true: false,
      },
      confirmPopup: false,
      externalSource: false,
			titleRetain: "",
			contentRetain: "",
      selectedType:"",
      lastSourceType:this.props.lastSourceType,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : []
    };

    this.clickButtonEvent = this.clickButtonEvent.bind(this);
    this.renderError = this.renderError.bind(this);
    this.saveMetricData = this.saveMetricData.bind(this);
    this.closeAsanaLogin = this.closeAsanaLogin.bind(this);
    this.closeJiraLogin = this.closeJiraLogin.bind(this);
    this.closeMspPopup = this.closeMspPopup.bind(this);
    this.updateJiraState = this.updateJiraState.bind(this);
    this.updateAsanaLogin = this.updateAsanaLogin.bind(this);
    this.updateAdoLogin = this.updateAdoLogin.bind(this);
    this.closeAdoLogin = this.closeAdoLogin.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.closeKpiMarketPlaceEdit = this.closeKpiMarketPlaceEdit.bind(this);
    this.updateSalesforceState = this.updateSalesforceState.bind(this);
    this.getKpiTypeFromItem = this.getKpiTypeFromItem.bind(this);
    this.changeRadio = this.changeRadio.bind(this);
  }

  componentWillUnmount() {
		this.props.metricRef(null)
	}
	
	componentDidMount() {
		this.props.metricRef(this)
    this.props.item && (
    this.props.setSavedAnnualDuration(this.props.item.isQuarter,this.props.item.quarter_name,this.props.item.id))
	}

  getKpiTypeFromItem() {
    let kpiType = "";
    if (this.props.item) {
      const source = this.props.item.source;
      const externalApp = this.props.item.ext_app_id;
      if (source == 10) {
        kpiType = "ds";
      } else if (source == 8) {
        const appName = getKpiExternalAppKpiTypeById(externalApp);
        if (this.isKpiAppIntegrationEnable(appName)) {
          kpiType = appName;
        }
      }
    }
    return kpiType;
  }

  clickButtonEvent(item) {
    this.setState({
      kpiType: item.id,
      errors: {},
      showAsanaLogin:
        item.id == "asa"
          ? !this.props.addOkrData.goalDetails.externalApps.asana
          : false,
      jira: {
        ...this.state.jira,
        shouldShowJiraLogin:
          item.id == "jira" ? !this.state.jira.jiraLoggedIn : false
      },
      showMSPLogin:
        item.id == "ms"
          ? !this.props.addOkrData.goalDetails.externalApps.ms_planner
          : false,
      salesforce: {
        isSelected: this.state.salesforce.isSelected,
        editMode: this.state.salesforce.editMode,
      }
    });
  }

  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }

  saveMetricData() {
    const {t} = this.props;
    let { kpiType } = this.state;
    let { krText, lastType, addEditFlag } = this.props;
    let errors = {};
    let isError = false;
    if (krText == "") {
      isError = true;
      this.props.showMetricNameErr();
			document.getElementById('metric-name-text').setAttribute('aria-invalid', 'true')
			setTimeout(() =>{
				document.getElementById('metric-name-text').focus()
			})
    }
    if (kpiType == "") {
      errors["kpi_type"] = t("Select a type of external source");
    }
    if (Object.keys(errors).length) {
      this.setState({ errors });
    } else {
      if (kpiType == "ms" && this.MsPlanner) {
        if(this.props.item.source != 8 && this.props.item.source == 1){        
					this.setState({
					  externalSource: true ,       
					  titleRetain: "",
					  contentRetain: "",
					})
				} else if (
          (this.props.item.source != 8 ||
            (this.props.item.source == 8 &&
              this.props.item.ext_app_id != 11)) &&
          addEditFlag
        ) {
          this.setState({ confirmPopup: true });
        } else {
          this.MsPlanner.saveMsPlannerData(isError);
        }
      }
    }
  }

  exitDeleteModal() {
    this.setState({ confirmPopup: false , externalSource : false });
  }

  saveItems() {
    let { kpiType } = this.state;
    let krText = this.props.krText;
    let errors = {};
    let isError = false;
    if (krText == "") {
      isError = true;
      this.props.showMetricNameErr();
    }
    // if(!this.props.owner.id){
    //   isError = true;
    //   this.props.showMetricOwnerErr();
    // }
    if (kpiType == "") {
      errors["kpi_type"] = t("Select a type of external source");
    }
    if (Object.keys(errors).length) {
      this.setState({ errors });
    } else {
      if (kpiType == "ms" && this.MsPlanner) {
        this.MsPlanner.saveMsPlannerData(isError);
        this.setState({ confirmPopup: false , externalSource : false });
      }
    }
  }

  updateAsanaLogin() {
    this.setState({
      showAsanaLogin: false
    });
  }

  closeAsanaLogin() {
    this.setState({
      showAsanaLogin: false,
      kpiType: this.getKpiTypeFromItem() || ""
    });

    this.props.cancelKpiTypeSelection(this.getKpiTypeFromItem() || '');
  }

  closeMspPopup() {
    this.setState({
      showMSPLogin: false,
      kpiType: this.getKpiTypeFromItem() || ""
    });
    this.props.cancelKpiTypeSelection(this.getKpiTypeFromItem() || '');
  }

  updateJiraState() {
    this.props.actions && this.props.actions.updateExtApp("jira");
    this.setState({
      jira: {
        ...this.state.jira,
        jiraLoggedIn: true,
        shouldShowJiraLogin: false
      }
    });
  }

  closeJiraLogin(isCancelEvent) {
    this.setState({
      jira: {
        ...this.state.jira,
        shouldShowJiraLogin: false
      },
      kpiType: isCancelEvent ? this.getKpiTypeFromItem() : "jira"
    });
    if (isCancelEvent) {
      this.props.cancelKpiTypeSelection(this.getKpiTypeFromItem() || '');
    }
  }

  updateAdoLogin(orgName, type) {
    this.props.actions && this.props.actions.updateExtApp("ado", type);
    this.setState({ isAdoConnected: type,  kpiType: "ado" });
  }

  closeAdoLogin(isCancelEvent) {
    this.setState({
      kpiType: isCancelEvent ? this.getKpiTypeFromItem() : ""
    });
    if (isCancelEvent) {
      this.props.cancelKpiTypeSelection(this.getKpiTypeFromItem() || '');
    }
  }

  handleCancel = () => {
    if(this.props.goBackFromMitNestedKr){
      this.props.goBackFromMitNestedKr();
    }else{
      this.props.closeKrRightPane(false, this.props.item.id ? this.props.item.id : '');
    }
  }
  
  updateSalesforceState(metric) {
    if (!metric) {
      return;
    }
    if (this.props.updateSingleItem) {
      this.props.updateSingleItem(metric);
    }

    this.setState({
      salesforce: {
        isSelected: this.state.kpiType === 'salesforce',
        editMode: (this.props.item && this.props.item.id && this.state.kpiType === 'salesforce') ? true: false,
      },
    });
  }

  closeKpiMarketPlaceEdit() {
    this.setState({kpiType: this.getKpiTypeFromItem() || ''})
    this.props.cancelKpiTypeSelection(this.getKpiTypeFromItem() || this.props.kpiType || '');
  }

  isKpiAppIntegrationEnable(appName) {
      return !this.props.integrations || !this.props.integrations[appName] || !(this.props.integrations[appName].visibility === false);
  }
  changeRadio(value) {
		const valueToSet = value
		this.setState(
		  {
			selectedType: valueToSet
		  }
		)
	}


  render() {
    const {t} = this.props;
    let kpiType = this.state.kpiType || this.props.kpiType;
    let buttons = [
      {
        id: "ds",
        label: t("Data streams"),
        iconClass: "icon icon-data-integration-24px-bluegreen ",
        buttonWrapperClass: kpiType == "ds" ? "active" : "",
        buttonClick: this.clickButtonEvent
      },
      {
        id: "jira",
        label: t("Jira"),
        iconClass: "icon icon-Jira-logo-24px",
        buttonWrapperClass: kpiType == "jira" ? "active" : "",
        buttonClick: this.clickButtonEvent
      },
      {
        id: "ado",
        label: t("Azure DevOps"),
        iconClass: "icon icon-azure_devops",
        buttonWrapperClass: kpiType == "ado" ? "active" : "",
        buttonClick: this.clickButtonEvent
      },
      {
        id: "asa",
        label: t("Asana"),
        iconClass: "icon icon-Asana_logo-24px",
        buttonWrapperClass: kpiType == "asa" ? "active" : "",
        buttonClick: this.clickButtonEvent
      },
      {
        id: "ms",
        label: t("MS Planner"),
        iconClass: "MSPlannerIcon",
        buttonWrapperClass: kpiType == "ms" ? "active" : "",
        buttonClick: this.clickButtonEvent
      },
    ];

    // respect feature flag
    if (this.isKpiAppIntegrationEnable('salesforce')) {
      buttons.push({
        id: 'salesforce',
        label: t('Salesforce'),
        iconClass: 'SalesforceIcon',
        buttonWrapperClass: this.state.salesforce.isSelected ? 'active': '',
        buttonClick: this.clickButtonEvent
      });
    }

    let renderKpiMetric = null;
    if (kpiType == "ds") {
      renderKpiMetric = (
        <DataStreamComp {...this.props} kpiType={kpiType} />
      );
    } else if (kpiType == "jira") {
      if (this.state.jira.jiraLoggedIn) {
        renderKpiMetric = (
          <JiraPostLogin
            {...this.props}
            jira={this.state.jira}
            kpiType={kpiType}
          />
        );
      } else if (this.state.jira.shouldShowJiraLogin) {
        renderKpiMetric = (
          <JiraIntegrationPopup
            closePopup={this.closeJiraLogin}
            updateParentState={this.updateJiraState}
          />
        );
      }
    } else if (kpiType == "asa") {
      if (this.props.addOkrData.goalDetails.externalApps.asana) {
        renderKpiMetric = (
          <AsanaPostLogin {...this.props} kpiType={kpiType} />
        );
      } else if (this.state.showAsanaLogin) {
        renderKpiMetric = (
          <AsanaLogin
            {...this.props}
            closeAsanaLogin={this.closeAsanaLogin}
            updateAsanaLogin={this.updateAsanaLogin}
          />
        );
      }
    } else if (kpiType == "ms") {
      renderKpiMetric = (
        <MsPlanner
          key="msplanner_comp"
          ref={ref => (this.MsPlanner = ref)}
          {...this.props}
          msp={this.state.msp}
          mspLogin={this.state.showMspLogin}
          mspClosePopUp={this.closeMspPopup}
          kpiType={kpiType}
        />
      );
    } else if (kpiType == "ado") {
      if (this.state.isAdoConnected) {
        renderKpiMetric = (
          <AdoPostLogin
            ref={this.props.kpiRef}
            authType={this.state.isAdoConnected}
            item={this.props.item}
            goalDetails={this.props.goalDetails}
            closeKrRightPane={this.props.closeKrRightPane}
            actions={this.props.actions}
            showMetricNameErr={this.props.showMetricNameErr}
            {...this.props}
          />
        );
      } else {
        renderKpiMetric = (
          <ADOPopup
            closePopup={this.closeAdoLogin}
            updateParentState={this.updateAdoLogin}
          />
        );
      }
    } else if (isKpiMarketPlaceExternalApp(this.props.item.ext_app_id) || kpiType == "wobo_kpi") {
      renderKpiMetric = (<KpiMarketPlaceDataSourceEdit
        {...this.props}
        kpiType={kpiType}
        isSelected={true}
        closePopup={this.closeKpiMarketPlaceEdit}
        item={this.props.item}
        actions={this.props.actions}
        onlyMetEdit={this.props.onlyMetEdit}
        closeKrRightPane={this.props.closeKrRightPane}
        lastSourceType={this.state.lastSourceType}
      />)
    }

    return (
      <div className="kpiSelWrapper width100">
        {/* <div>
          <div className="wherekrDataCome">
            What external source do you want to pull data from?
            <TypeFaceText key="typeface" />
          </div>
          <div className="kpiSelDiv">
            <ButtonsComp
              key="kpi-buttons"
              buttons={buttons}
              addEditFlag={this.props.addEditFlag}
            />
            {this.renderError("kpi_type")}
          </div>
        </div> */}
        <div id="renderIntegration">{renderKpiMetric}</div>
        {this.state.confirmPopup && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t("Save Key Result with New Data Type")}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t("Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data") + '.'} 
            buttonText={t("Save")}
          />
        )}
        {
					this.state.externalSource  &&
					<RetainUpdateModal
							selectedType={this.state.selectedType}
							changeRadio={this.changeRadio}
							exitDeleteModal={this.exitDeleteModal}
							deleteItems={this.saveItems}
							titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type") }
							contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result")+ '?' : t("Are you sure you want to save this key result with the new data type selected")+ '?'}
						/>
				}
      </div>
    );
  }
}

export default withTranslation()(KpiTypeComp)